import 'reactjs-popup/dist/index.css'

import DashboardLayout from '../../layouts/LayoutContainers/DashboardLayout'

import 'animate.css'
import FiltersPopup from './components/FiltersPopup'
import HistoryTabs from './components/HistoryTabs'
import HistoryContent from './components/HistoryContent'
import useHistory from './useHistory'

const BasicTabs = () => {
  const {
    filterOnMobile,
    handleChange,
    allTags,
    isLoading,
    grids,
    filteredGrids,
    subjects,
    filteredCorrect,
    filteredTags,
    setFiltersPopupOpened,
    setFilteredCorrect,
    setFilteredTags,
    closeModal,
    filtersPopupOpened,
    difficultyFilters,
    handleSelectDifficulty,
    hasSubscription,
    setDifficultyFilters,
    handleChangeChaptersByCourse,
    savedGrids,
    setSavedGrids,
    filteredSavedGrids,
    isNoteModalOpened,
    setIsNoteModalOpened,
    handleUpdateNote,
    grileTypes,
    handleChangeGrileTypes,
    books,
  } = useHistory()

  return (
    <DashboardLayout className="absolute">
      <div className="flex max-w-[800px] ml-auto mr-auto transition-all duration-700 ease-in-out">
        <div className="ml-auto mr-auto relative w-full ">
          <HistoryTabs
            filterOnMobile={filterOnMobile}
            handleChange={handleChange}
          />
          <HistoryContent
            handleUpdateNote={handleUpdateNote}
            isNoteModalOpened={isNoteModalOpened}
            setIsNoteModalOpened={setIsNoteModalOpened}
            setSavedGrids={setSavedGrids}
            savedGrids={savedGrids}
            filteredGrids={filteredGrids}
            filteredSavedGrids={filteredSavedGrids}
            allTags={allTags}
            isLoading={isLoading}
            grids={grids}
            subjects={subjects}
            filterOnMobile={filterOnMobile}
            filteredCorrect={filteredCorrect}
            filteredTags={filteredTags}
            setOpen={setFiltersPopupOpened}
            books={books}
          />
        </div>
        <FiltersPopup
          handleChangeGrileTypes={handleChangeGrileTypes}
          grileTypes={grileTypes}
          handleChangeChaptersByCourse={handleChangeChaptersByCourse}
          includeAdditionalCheckboxes={filterOnMobile === 1}
          setDifficultyFilters={setDifficultyFilters}
          hasSubscription={hasSubscription}
          difficultyFilters={difficultyFilters}
          handleSelectDifficulty={handleSelectDifficulty}
          filteredTags={filteredTags}
          setFilteredCorrect={setFilteredCorrect}
          setFilteredTags={setFilteredTags}
          filteredCorrect={filteredCorrect}
          closeModal={closeModal}
          filtersPopupOpened={filtersPopupOpened}
        />
      </div>
    </DashboardLayout>
  )
}

export default BasicTabs
